module.exports = __webpack_public_path__ + "static/media/logo.429763e0.svg";